module.exports = __webpack_public_path__ + "static/media/Hangman_1920x1080.6d866cce.png";